module.exports = __webpack_public_path__ + "img/img-scan.17dce3d4.png";